import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Box, Typography, Button, TextField, Divider } from '../../../../../components/mui/Core/index'
import LockOpenIcon from '@mui/icons-material/LockOpen'

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 480,
  bgcolor: '#ffffff',
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
  outline: 'none',
}

function ReleaseHoldModal({ open, hold, isReleaseAll, onConfirm, onClose, isSubmitting }) {
  const [comment, setComment] = useState('')

  const handleConfirm = () => {
    onConfirm(comment)
    setComment('')
  }

  const handleClose = () => {
    setComment('')
    onClose()
  }

  const title = isReleaseAll ? 'Release All Holds' : `Release Hold — ${hold?.holdCode}`
  const body = isReleaseAll
    ? 'This will release all releasable holds on this order. Locked holds will not be affected.'
    : `Are you sure you want to release the ${hold?.holdCode} hold? (${hold?.description})`

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
          <LockOpenIcon sx={{ color: '#2db47d', fontSize: 22 }} />
          <Typography sx={{ fontFamily: 'SanomatMedium', fontSize: '1.1rem', color: '#145a4b' }}>
            {title}
          </Typography>
        </Box>
        <Divider sx={{ mb: 2 }} />
        <Typography sx={{ fontFamily: 'AtlasGroteskRegular', fontSize: '0.9rem', color: '#262626', mb: 2 }}>
          {body}
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          size='small'
          label='Release comment (optional)'
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          sx={{ mb: 3, '& *': { fontFamily: 'AtlasGroteskRegular' } }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5 }}>
          <Button
            variant='outlined'
            onClick={handleClose}
            disabled={isSubmitting}
            sx={{ fontFamily: 'AtlasGroteskRegular', textTransform: 'none', fontSize: '0.85rem' }}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color='secondary'
            onClick={handleConfirm}
            disabled={isSubmitting}
            sx={{ fontFamily: 'AtlasGroteskRegular', textTransform: 'none', fontSize: '0.85rem' }}
          >
            {isSubmitting ? 'Releasing…' : 'Confirm Release'}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

ReleaseHoldModal.propTypes = {
  open: PropTypes.bool.isRequired,
  hold: PropTypes.object,
  isReleaseAll: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
}

export default ReleaseHoldModal
